import React from 'react';
import Styles from '../../assets/css/error/notFound.module.scss';

const NotFound = () => {
  const handleBackToHome = () => {
    // Navigate back to home - replace with your routing logic
    window.location.href = '/stocklevels';
  };

  return (
    <div className={`${Styles.notFoundContainer}`}>
      <div className={`${Styles.notFoundContent}`}>
        <div className={`${Styles.errorCode}`}>
          <span className={`${Styles.four}`}>4</span>
          <div className={`${Styles.zeroCircle}`}>
            <div className={`${Styles.circleStroke}`}></div>
          </div>
          <span className={`${Styles.four}`}>4</span>
        </div>
        
        <div className={`${Styles.errorMessage}`}>
          <h1>Page Not Found</h1>
          <p>The requested warehouse resource could not be located or does not exist.</p>
        </div>
        
        <button 
          className={`${Styles.backBtn}`} 
          onClick={handleBackToHome}
          aria-label="Return to warehouse dashboard"
        >
          Back to Dashboard
          <span className={`${Styles.arrow}`}>→</span>
        </button>
      </div>
      
      <div className={`${Styles.backgroundShapes}`}>
        <div className={`${Styles.shape} ${Styles.shape1}`}></div>
        <div className={`${Styles.shape} ${Styles.shape2}`}></div>
        <div className={`${Styles.shape} ${Styles.shape3}`}></div>
      </div>
    </div>
  );
};

export default NotFound;